export default __webpack_public_path__ + "static/media/home-restaurant-img-10.3b713f71.jpg";